/*
 * @Author: Yue Hu(yuhu@nvidia.com)
 * @Date: 2024-11-16 11:33:19
 * @LastEditors: Yue Hu(yuhu@nvidia.com)
 * @LastEditTime: 2024-11-21 21:50:05
 * @FilePath: /mooctest.com/src/main.js
 */
// =========================================================
// * Vue Material Kit - v1.2.2
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-kit
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
// * Licensed under MIT (https://github.com/creativetimofficial/vue-material-kit/blob/master/LICENSE.md)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
import Vue from "vue";
import Element from "element-ui";
import Buefy from "buefy";
import i18n from "./i18n/i18n";
import App from "./App.vue";
import router from "./router";
import "element-ui/lib/theme-chalk/index.css";

import "buefy/dist/buefy.css";

import MaterialKit from "./plugins/material-kit";

Vue.config.productionTip = false;
Vue.use(Element);
// Vue.use(Element,{i18n:(key,value)=>i18n.t(key, value)});
Vue.use(MaterialKit);
Vue.use(Buefy);

const NavbarStore = {
  showNavbar: false,
};

Vue.mixin({
  data() {
    return {
      NavbarStore,
    };
  },
});

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
